import { EmploymentStatus } from '@axo/shared/data-access/types';
import { Broker } from '@axo/shared/data-access/types/broker';

type GetEmploymentStatusVisibilityArgs = {
  employmentStatus: EmploymentStatus;
  broker: Broker;
  hasJobPosition?: boolean;
};

export const getEmploymentStatusVisibility = ({
  employmentStatus,
  broker,
  hasJobPosition,
}: GetEmploymentStatusVisibilityArgs) => {
  const employmentStatuses = [
    EmploymentStatus.Permanent,
    EmploymentStatus.Temporary,
    EmploymentStatus.ParentalLeave,
    EmploymentStatus.Entrepreneur,
    EmploymentStatus.Farmer,
  ];

  const askEmploymentDetails = employmentStatuses.includes(employmentStatus);

  const zmartaEmploymentStatuses = [
    ...employmentStatuses,
    EmploymentStatus.Pensioner,
    EmploymentStatus.Unemployed,
    EmploymentStatus.Student,
  ];

  const employmentStatusesSince =
    broker === Broker.Zmarta ? zmartaEmploymentStatuses : employmentStatuses;

  const askEmploymentStatusSince =
    employmentStatusesSince.includes(employmentStatus);

  const askJobPosition =
    hasJobPosition &&
    [
      EmploymentStatus.Permanent,
      EmploymentStatus.Temporary,
      EmploymentStatus.ParentalLeave,
    ].includes(employmentStatus);

  const askEmploymentStatusUntil = [EmploymentStatus.Temporary].includes(
    employmentStatus
  );

  return {
    askEmploymentDetails,
    askEmploymentStatusSince,
    askEmploymentStatusUntil,
    askJobPosition,
  };
};
